'use strict';

module.exports = function (Chart) {
  Chart.Bubble = function (context, config) {
    config.type = 'bubble';
    return new Chart(context, config);
  };
};